import React, { useState } from "react";
import { Box, Button, Typography, Grid, Divider, Pagination } from "@mui/material";

const classesData = new Array(8).fill({
  title: "Learn How To Design Seamless Notification Se...",
  date: "14 Nov 2024",
  percentageViewed: "0.0%",
});

const CommunityClass = () => {
  const [page, setPage] = useState(1);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box sx={{ padding: "20px", border: "1px solid #ccc", borderRadius: "8px" }}>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Community Classes
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Important: These sessions are optional and do not affect your overall progress in the course.
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {classesData.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "16px", textAlign: "center" }}>
              <Typography variant="body1" fontWeight={500} gutterBottom>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Percentage Viewed: {item.percentageViewed}
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                {item.date}
              </Typography>
              <Button variant="contained" size="small">Watch Recording</Button>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box display="flex" justifyContent="center" mt={3}>
        <Pagination count={20} page={page} onChange={handlePageChange} color="primary" />
      </Box>
    </Box>
  );
};

export default CommunityClass;
